function showContinent(continent) {
	let countries = document.getElementsByClassName('country');
	let filters = document.getElementsByClassName('country-filter');

	for (let i = 0; i < countries.length; i++) {
		countries[i].classList.remove('d-none');
	}

	for (let i = 0; i < filters.length; i++) {
		filters[i].classList.remove('active');
	}

	if (continent === 'all') {
		document.querySelector(`.country-filter[data-filter-countries='all']`).classList.add('active');
	} else {
		for (let i = 0; i < countries.length; i++) {
			if (countries[i].dataset.continent !== continent) {
				countries[i].classList.add('d-none');
			}
		}
		document.querySelector(`.country-filter[data-filter-countries='${continent}']`).classList.add('active');
	}

	return false;
}

document.addEventListener('DOMContentLoaded', function () {
	const button = document.querySelector('.js-hero-gc-button');
	if (!button) {
		return;
	}

	button.addEventListener('click', function () {
		const selectedValue = document.querySelector('.js-hero-gc-select');
		let goToUrl = '/buy/gift_card/';

		if (selectedValue.value) {
			goToUrl += selectedValue.value;
		}
		window.location.href = s.url(goToUrl);
	});
});